import React, { Component } from 'react';
import FileUploader from 'react-firebase-file-uploader';
import { serverIp, firebaseAuth, toCurrency, firebaseStorage, logComponentLoad } from '../../../../config/constants.js'
import { Form, Segment, Button, Header, Divider, Icon, Image } from 'semantic-ui-react';
import * as UiConsts from '../../../../config/UiConstants';
import axios from 'axios';
import { SingleDatePicker } from 'react-dates';
//import { getPrintValues, getDesigners, checkAdminEmail } from '../../dashBoard/newDashboard/algoliaDashboard/AlgoliaMiscUtils';
import { checkAdminEmail, getPrintValues } from '../algoliaDashboard/AlgoliaMiscUtils';
import Select from 'react-select';
import ViewRequisitionsDropdown from '../Requisition/ViewRequisitionsDropdown.js';
import ProjectsSearchNow from '../LargeProjects/ProjectsSearchNow.js';
import { Link } from 'react-router-dom'

import createBrowserHistory from 'history/createBrowserHistory';
const history = createBrowserHistory({ forceRefresh: true });



class UpdateSingleZapierNotif extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,

            fromWhereZapier: '',
            fromWhereZapierStockAcc: '',
            fromWhereOptions: [],
            fromWhereZapierStockAccOptions: [],
            zapierNotif: '',
            openProjectsDropdownItemList: [],
            isProject: false,
            note: '',
            confirming: true,
            unpaid_req: 0,
            sendNewNotif: false,
            viewPayReqLink: false

        }
    }


    componentDidMount() {
        console.log("entx8 +++++ componentDidMount - ");

        this.removeListener = firebaseAuth().onAuthStateChanged((user) => {
            console.log("elx1 +++++++++:removeListener");


            if (user) {
                if (user.email) {
                    console.log("addx290 user.email  is:" + user.email);
                    this.setState({
                        user: user
                    })

                    //CHECK ALGOLIA FOR USER
                    checkAdminEmail(user.email, this.setAdminResult)
                }

            } else {
                console.log("rlx121 user NOT found");
                this.setState({
                    authed: false,
                    // loading: false,
                    user: user,
                    uid: user.uid
                })
            }


        })
    }

    fromWhere = (statuses) => {
        //  console.log("ddx12 ++++++ loadStatuses ");
        // console.log("ddx121 statuses:" + JSON.stringify(statuses, null, 3));
        this.setState({ fromWhereOptions: statuses })
    }

    fromWhereStock = (statuses) => {
        //  console.log("ddx12 ++++++ loadStatuses ");
        // console.log("ddx121 statuses:" + JSON.stringify(statuses, null, 3));
        this.setState({ fromWhereZapierStockAccOptions: statuses })
    }

    setAdminResult = (returnObject) => {
        // console.log("++++++ addx294 setAdminResult");
        // console.log("addx2941 returnObject:" + JSON.stringify(returnObject, null, 3));

        logComponentLoad(returnObject, "UpdateZapierNotifs");

        getPrintValues("fromWhereZapier", this.fromWhere);

        getPrintValues("fromWhereZapierStockAcc", this.fromWhereStock);

        // GET Projects
        this.getOpenProjectsDropdownList();

        if (this.props.match.params.idzapierNotifs) {
            this.getSingleZapierNotif(this.props.match.params.idzapierNotifs);
            // this.getOpenProjectsDropdownList();

        } else {
            this.setState({
                sendNewNotif: true
            })
            console.log("this.props.match.params.idzapierNotifs NOT SENT");
        }

        this.setState({
            algoliaUser: returnObject.algoliaUser,
            //isAdmin: returnObject.isAdmin,
        })
    }

    getOpenProjectsDropdownList = () => {
        console.log("cpx1 ======getOpenProjectsDropdownList");

        this.setState({ loading: true })

        axios.post(serverIp + 'large_projects/getProjectsDropdownList', {
            apiKey: "getSingleZapierNotif",
            projectTypesToGet: "recent",
            "numRecords": 60
        })
            .then((response) => {
                this.setState({ loading: false })
                console.log(response.data);

                if (response.data.openProjectsDropdownItemList) {
                    console.log("true.. setting openProjectsDropdownItemList");

                    this.setState({
                        openProjectsDropdownItemList: response.data.openProjectsDropdownItemList
                    });

                } else {
                    console.log("FAILED");
                    alert("FAILED TO get zapierNotif:");
                }
            })
            .catch((error) => {
                console.log(error);
                this.setState({
                    loading: false
                })
            });
    }

    getSingleZapierNotif = (idzapierNotifs) => {
        console.log("cpx1 ======getSingleZapierNotif");
        console.log("idzapierNotifs:" + idzapierNotifs);

        this.setState({ loading: true })

        axios.post(serverIp + 'stockPayment/getSingleZapierNotif', {
            apiKey: "getSingleZapierNotif",
            idzapierNotifs: idzapierNotifs
        })
            .then((response) => {
                this.setState({ loading: false })
                console.log(response.data);

                if (response.data.result && response.data.zapierNotif) {
                    console.log("true.. setting zapierNotif");

                    this.setState({
                        zapierNotif: response.data.zapierNotif
                    });

                    if (response.data.zapierNotif.regexAmount) {
                        this.setState({
                            amount: response.data.zapierNotif.regexAmount
                        });
                    }

                } else {
                    console.log("FAILED");
                    alert("FAILED TO get zapierNotif:");
                }
            })
            .catch((error) => {
                console.log(error);
                this.setState({
                    loading: false
                })
            });
    }

    handleTextInputChange = (e) => {
        // console.log("hx1 >>>>: handleTextInputChange clicked");
        // console.log("hx33 e.target.type:" + e.target.type);
        console.log("hx32 e.target.name:" + e.target.name);
        console.log("hx34 e.target.value:" + e.target.value);
        let newState = {};
        newState[e.target.name] = e.target.value;

        let name = e.target.name;
        let value = e.target.value;

        this.setState(newState);

    }

    dateSelectOnChange = (date) => {
        console.log("+++++++:dateSelectOnChange");
        console.log("date sent:" + date)
        console.log("dateString:" + date.format('dddd MMMM Do'));
        this.setState({
            selectedDate: date.valueOf(),
            dateString: date.format('dddd MMMM Do')
        })

        console.log(date.valueOf());
    }

    // ##########################::  FIRST :##########################:
    confirmZapierLog = () => {
        console.log("entx1 +++++ sendAworiLog - ");

        //if (this.state.depositAmount.length < 4) {
        if (this.state.fromWhereZapier == '' && this.state.fromWhereZapierStockAcc == '') {
            alert("error, from where is null");

        } else if (this.state.reason == '') {
            alert("error, pls enter a note to confirm");

        } else {

            this.setState({ loading: true });
            console.log("entx122 checking order numbers");

            let tempFromWhere = "none";

            if (this.state.fromWhereZapierStockAcc != '') {

                tempFromWhere = this.state.fromWhereZapierStockAcc;

            } else if (this.state.fromWhereZapier != '') {

                tempFromWhere = this.state.fromWhereZapier;
            }



            // SEND CHECK TO SERVER
            //axios.post(pythonApiIp + 'enterAworiLog', {
            axios.post(serverIp + 'stockPayment/confirmZapierLog', {
                apiKey: "confirmZapierLog",
                idzapierNotifs: this.props.match.params.idzapierNotifs,
                amountSent: this.state.amount,
                reason: this.state.reason,
                fromWhere: tempFromWhere,
                enteredBy: this.state.user.email,
                zapierProjectId: this.state.project,
                requisitionId: parseInt(this.state.unpaid_req)
            })
                .then((response) => {
                    // console.log("entx221 response:" + JSON.stringify(response.data, null, 3));

                    // console.log("entx22 result:" + response.data.result);

                    // CHECK RECEIPTS
                    if (response.data.result) {

                        this.setState({ loading: false });
                        alert("Success:" + response.data.message);

                        //this.clearFields();

                        this.getSingleZapierNotif(this.props.match.params.idzapierNotifs);
                    } else if (!response.data.result) {
                        alert("Error:" + response.data.message);
                        this.setState({ loading: false });
                    }



                })
                .catch((error) => {
                    console.log(error);
                    //this.setState({ loading: false })
                    // this.clearFields();
                });

        }
    }

    // ##########################: MANUAL ENTRY :##########################:
    manualEnterZapierLog = () => {
        console.log("entx1 +++++ manualEnterZapierLog - ");

        //if (this.state.depositAmount.length < 4) {
        if (this.state.fromWhereZapier == '' && this.state.fromWhereZapierStockAcc == '') {
            alert("error, from where is null");

        } else if (this.state.reason == '') {
            alert("error, pls enter a note to confirm");

        } else {

            this.setState({ loading: true });
            console.log("entx122 checking order numbers");

            let tempFromWhere = "none";

            if (this.state.fromWhereZapierStockAcc != '') {

                tempFromWhere = this.state.fromWhereZapierStockAcc;

            } else if (this.state.fromWhereZapier != '') {

                tempFromWhere = this.state.fromWhereZapier;
            }

            let tempAmount = this.state.amount;

            if (this.state.fromWhereZapierStockAcc == 'capital_put_back') {
                console.log("fromWhereZapierStockAcc is capital_put_back");
                //tempFromWhere = 'largeProject';
                tempAmount = tempAmount * -1;
                console.log("tempAmount:" + tempAmount)
            }

            if (this.state.fromWhereZapierStockAcc == 'capital_put_back') {
                console.log("fromWhereZapierStockAcc is capital_put_back");
                //tempFromWhere = 'largeProject';
                tempAmount = tempAmount * -1;
                console.log("tempAmount:" + tempAmount)
            }

            // FOR DEDUCTION
            let tempSentToAccount = undefined;
            if (this.state.fromWhereZapierStockAcc == 'capital_deduction') {
                console.log("fromWhereZapierStockAcc is capital_deduction");
                //tempFromWhere = 'largeProject';
                tempAmount = tempAmount * -1;
                console.log("tempAmount:" + tempAmount)
                tempSentToAccount = 'capital_deduction';
                tempFromWhere = 'capital_put_back'
            }

            console.log("tempSentToAccount:" + tempSentToAccount);
            // SEND CHECK TO SERVER
            //axios.post(pythonApiIp + 'enterAworiLog', {
            axios.post(serverIp + 'stockPayment/manualEnterZapierLog', {
                apiKey: "confirmZapierLog",
                amountSent: tempAmount,
                selectedDate: this.state.selectedDate,
                fromWhere: tempFromWhere,
                action: "deduct",
                reason: this.state.reason,
                enteredBy: this.state.user.email,
                zapierProjectId: this.state.project,
                requisitionId: parseInt(this.state.unpaid_req),
                sentToAccount: tempSentToAccount
            })
                .then((response) => {
                    // console.log("entx221 response:" + JSON.stringify(response.data, null, 3));

                    // console.log("entx22 result:" + response.data.result);

                    // CHECK RECEIPTS
                    if (response.data.result) {

                        this.setState({ loading: false });
                        alert("Success:" + response.data.message);

                        //this.clearFields();
                        if (response.data.zapierNotif) {
                            // this.getSingleZapierNotif(response.data.zapierNotif.idzapierNotifs);

                            history.push("/dashboard/updateSingleZapierNotif/" + response.data.zapierNotif.idzapierNotifs);
                        }

                    } else if (!response.data.result) {
                        alert("Error:" + response.data.message);
                        this.setState({ loading: false });
                    }
                })
                .catch((error) => {
                    console.log(error);
                    //this.setState({ loading: false })
                    // this.clearFields();
                });

        }
    }

    clearFields = () => {

        this.setState({
            loading: false,
            reason: '',
            fromWhereZapier: ''
        })
    }

    handleDropDownChanges = (value) => {
        console.log("req1 handleDropDownChanges");
        console.log('req2 You\'ve sss:', JSON.stringify(value, null, 3));

        if (value) {
            console.log("req3 category alone:" + value.category);
            console.log('req4 You\'ve selected:', value.value + " " + value.category);

            let newState = {};
            newState[value.category] = value.value;
            console.log("req5 newState 1:" + JSON.stringify(newState, null, 3));

            if ((value.category == 'fromWhereZapier' || value.category == 'fromWhereZapierStockAcc') && (value.value == 'largeProject') || value.value == 'capital_put_back' || value.value == 'operations') {
                newState['isProject'] = true;

            } else if ((value.category == 'fromWhereZapier' || value.category == 'fromWhereZapierStockAcc') && value.value != 'largeProject') {
                newState['isProject'] = false;

            }

            if ((value.category == 'fromWhereZapier' || value.category == 'fromWhereZapierStockAcc')) {
                newState['reason'] = value.value;
            }

            if (value.category == 'project') {
                newState['reason'] = value.label;
            }


            if (value.category == 'unpaid_req') {
                console.log("req6 selected:" + value.label);
                console.log("req7 piad:" + value.item_id)

                if (value.item_id == 'yes') {
                    console.log("its paid");
                    newState['viewPayReqLink'] = false;
                } else if (value.item_id == 'no') {
                    console.log("its NOT paid");
                    newState['viewPayReqLink'] = true;
                }
            }



            //this.setState(newState);
            this.setState(newState);
        }
    }

    /**
* HANDLE THE FILE UPLOADING..
*/
    handleUploadStart = (file) => {
        console.log("docx14 ++++++ handle uploadStart file:" + file.name.split('.')[0]);

        this.setState({ isUploading: true, progress: 0, actualFileName: file.name });
    }

    handleUploadSuccess = (saveFileName) => {
        console.log("docx15 +++++++handleUploadSuccess");

        this.setState({ fileName: saveFileName, isUploading: false, progress: 100 });

        //UDPATE URL 
        // let orderKey = this.props.fileName;
        firebaseStorage.ref('printbdocs').child(saveFileName).getDownloadURL().then(
            url => {
                this.setState({ docUrl: url })
                console.log("docx16 docUrl is:" + url);

                // let tempRef = db.ref('orders').child(orderKey);
                // //UDPATE FIREBASE OBJECT WITH OBJECT NAME..
                // tempRef.update('fileUrl':url);

                // let updates = {};
                // updates['/orders/' + orderKey + '/fileUrl'] = url;
                // updates['/orders/' + orderKey + '/fileName'] = saveFileName;
                // updates['/orders/' + orderKey + '/usersFileName'] = this.state.actualFileName;
                // ref.update(updates);
                this.updateWhenFileUploadComplete(true, this.state.actualFileName, url);
            }
        );
    };

    handleProgress = (progress) => this.setState({ progress });
    handleUploadError = (error) => {
        console.log("docx16 +++++++: handleUploadError");

        this.setState({ isUploading: false });
        console.error(error);
    }

    updateWhenFileUploadComplete = (uploaded, fileName, url) => {
        console.log("docx17 +++++++: updateWhenFileUploadComplete");
        console.log("docx181 uploaded:" + uploaded);
        console.log("docx18 fileName:" + fileName);
        console.log("docx19 url:" + url)
    }

    // ##########################: MANUAL ENTRY :##########################:
    masterAccountTransferApi = () => {
        console.log("Mentx1 +++++ masterAccountTransferApi - ");

        //if (this.state.depositAmount.length < 4) {
        if (this.state.reason == '') {
            alert("error, pls enter a note to confirm");

        } else if (this.state.zapierNotif == '') {
            alert("error, notification not loaded");

        } else if (!this.state.selectedDate) {
            alert("error, pls selectDate");

        } else if (!this.state.docUrl) {
            alert("error, no receipt uploaded");

        } else {

            this.setState({ loading: true });
           
            console.log("zapierNotif:"+JSON.stringify(this.state.zapierNotif,null,3));

            let tempProjectId = this.state.zapierNotif.largeProject
                ? this.state.zapierNotif.largeProject.idlargeProjects
                : null

           // alert("project id:"+tempProjectId);

            axios.post(serverIp + 'billing/masterAccountTransferApi', {
                apiKey: "confirmZapierLog",
                amountSent: this.state.zapierNotif.regexAmount,
                selectedDate: this.state.selectedDate,
                //fromWhere: "capital_put_back",
                fromWhere: this.props.match.params.putBack,
                action: "deduct",
                //reason: this.state.zapierNotif.reason + "_capital_put_back",
                reason: this.state.zapierNotif.reason + "_" + this.props.match.params.putBack,
                enteredBy: this.state.user.email,
                zapierProjectId: tempProjectId,
                accountType: this.state.zapierNotif.accountType,
                idzapierNotifs: this.state.zapierNotif.idzapierNotifs,
                sentToAccount: 'zp',
                imageUrl: this.state.docUrl
                // requisitionId: parseInt(this.state.unpaid_req)
            })
                .then((response) => {
                    console.log("entx221 response:" + JSON.stringify(response.data, null, 3));

                    if (response.data.result) {
                        this.setState({ loading: false });
                        alert("Success:" + response.data.message);

                        if (response.data.zapierNotif) {

                            history.push("/dashboard/updateSingleZapierNotif/" + response.data.zapierNotif.idzapierNotifs + "/" + this.props.match.params.putBack
                            );
                        }

                    } else if (!response.data.result) {
                        alert("Error:" + response.data.message);
                        this.setState({ loading: false });
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.setState({ loading: false })
                    // this.clearFields();
                });
        }
    }

    render() {

        const projectDropdown = this.state.openProjectsDropdownItemList.length > 0 && this.state.isProject
            ? <div>
                <label> PROJECT </label>
                <Select
                    name="form-field-name"
                    value={this.state.project}
                    options={this.state.openProjectsDropdownItemList}
                    onChange={this.handleDropDownChanges}
                    searchable={true}
                    clearable={false}
                />
            </div>
            : ''

        const headerStuff = this.state.zapierNotif != ''
            ? <div>

                <Header as='h3' color='teal'>
                    {this.state.zapierNotif.idzapierNotifs}
                    <Header.Subheader>
                        ID
                    </Header.Subheader>
                </Header>

                <Header as='h3' color='green'>
                    {this.state.zapierNotif.accountType}
                    <Header.Subheader>
                        ACCOUNT
                    </Header.Subheader>
                </Header>

                <Header as='h3' color='teal'>
                    {this.state.zapierNotif.zapierDate}
                    <Header.Subheader>
                        DATE
                    </Header.Subheader>
                </Header>

                <Header as='h3' color='teal'>
                    {toCurrency(this.state.zapierNotif.regexAmount)}
                    <Header.Subheader>
                        AMOUNT
                    </Header.Subheader>
                </Header>

                <Header as='h3' color='teal'>
                    {this.state.zapierNotif.depOrDed}
                    <Header.Subheader>
                        ACTION
                    </Header.Subheader>
                </Header>

                <Header as='h3' color='teal'>
                    REASON
                    <Header.Subheader>
                        {this.state.zapierNotif.reason}
                    </Header.Subheader>
                </Header>

                <Header as='h3' color='teal'>
                    MESSAGE
                    <Header.Subheader>
                        {this.state.zapierNotif.zapierEmailText}
                    </Header.Subheader>
                </Header>


            </div>
            : ''

        const not_confirmedHeader = this.state.zapierNotif != ''
            && this.state.zapierNotif.acked == 'no'
            ? <div>
                <Divider horizontal>{'NOT CONFIRMED'}</Divider>
                <Header as='h1' color='red'>
                    <Icon name='x' />
                    NOT CONFIRMED
                    <Header.Subheader>
                        CONFIRMED
                    </Header.Subheader>
                </Header>
            </div>
            : ''

        const reqDropDown = this.state.user && this.state.zapierNotif != ''
            && this.state.zapierNotif.acked == 'no'
            ? <div>
                <ViewRequisitionsDropdown
                    user={this.state.user}
                    unpaid_req={this.state.unpaid_req}
                    handleDropDownChanges={this.handleDropDownChanges}
                    title="All - Requisiton (Optional)"
                    type="all" />
            </div>
            : ''

        const unPaidReqLink = this.state.viewPayReqLink ?
            <div>
                <Button color='green' fluid>
                <Link to={'/dashboard/viewRequisition/' + parseInt(this.state.unpaid_req)} target="_blank">Pay Requisition</Link>
          
                </Button>
          </div>
            : ''
        // const unPaidReqDropDown = this.state.user && this.state.zapierNotif != ''
        //     && this.state.zapierNotif.acked == 'no'
        //     ? <div>
        //         <ViewRequisitionsDropdown
        //             user={this.state.user}
        //             unpaid_req={this.state.unpaid_req}
        //             handleDropDownChanges={this.handleDropDownChanges}
        //             title="Requisiton (Optional)"
        //             type="not_paid" />
        //     </div>
        //     : ''

        const pbAccountFromWhereOptions = this.state.zapierNotif != ''
            && this.state.zapierNotif.acked == 'no'
            // && (this.state.zapierNotif.accountType == 'printbodaAccount' || this.state.zapierNotif.regexAmount > 0)
            && (this.state.zapierNotif.regexAmount > 0)
            ? <div>
                <label> FROM WHERE - {this.state.fromWhereZapier} </label>
                <Select
                    name="form-field-name"
                    value={this.state.fromWhereZapier}
                    options={this.state.fromWhereOptions}
                    onChange={this.handleDropDownChanges}
                    searchable={false}
                    clearable={false}
                />
            </div>
            : ''

        const stockAccountFromWhereOptions = this.state.zapierNotif != ''
            && this.state.zapierNotif.acked == 'no'
            && (this.state.zapierNotif.accountType == 'stockAccount' || this.state.zapierNotif.regexAmount < 0)
            ? <div>
                <label> REASON - {this.state.fromWhereZapier} </label>
                <Select
                    name="form-field-name"
                    value={this.state.fromWhereZapierStockAcc}
                    options={this.state.fromWhereZapierStockAccOptions}
                    onChange={this.handleDropDownChanges}
                    searchable={false}
                    clearable={false}
                />
            </div>
            : ''

        const confirmForm = this.state.zapierNotif != '' && this.state.zapierNotif.acked == 'no' && !this.props.match.params.putBack
            ? <div>
                <Form size='large' onSubmit={this.confirmZapierLog}>
                    <Segment stacked>
                        <br />
                        {pbAccountFromWhereOptions}
                        {stockAccountFromWhereOptions}
                        {reqDropDown}
                        {unPaidReqLink}

                        <br />
                        {projectDropdown}

                        {/* amount */}
                        <Form.Field>
                            <label>Amount </label>
                            <label>{toCurrency(this.state.amount)}</label>
                            <Form.Input
                                fluid
                                name={'amount'}
                                value={this.state.amount}
                                icon='add user'
                                iconPosition='left'
                                placeholder='amount'
                                // onFocus={props.amp_logFieldClick}
                                onChange={this.handleTextInputChange}
                                type='number' />
                        </Form.Field>

                        {/* depositAmount*/}
                        <Form.Field>
                            <label>Note</label>
                            <Form.Input
                                fluid
                                name={'reason'}
                                value={this.state.reason}
                                icon='add user'
                                iconPosition='left'
                                placeholder='Note'
                                onChange={this.handleTextInputChange}
                                type='text' />
                        </Form.Field>

                        <Button color='blue' fluid size='large'>CONFIRM</Button>
                    </Segment>
                </Form>
            </div>
            : ''

        const projectUi = this.state.zapierNotif != '' && this.state.zapierNotif.largeProject
            ? <div>
                <Header as='h3' color='teal'>
                    {this.state.zapierNotif.largeProject.name}
                    <Header.Subheader>
                        PROJECT
                    </Header.Subheader>
                </Header>
            </div>
            : ''

        const ackedUi = this.state.zapierNotif != '' && this.state.zapierNotif.acked == 'yes'
            ? <div>
                <Divider horizontal>{'ACKNOWLEDGED'}</Divider>
                <Header as='h1' color='green'>
                    <Icon name='check circle' />
                    {this.state.zapierNotif.ackedBy}
                    <Header.Subheader>
                        CONFIRMED BY
                    </Header.Subheader>
                </Header>

                <Header as='h3' color='blue'>
                    {this.state.zapierNotif.fromWhere}
                    <Header.Subheader>
                        FROM WHERE
                    </Header.Subheader>
                </Header>

                {projectUi}
            </div>
            : ''

        const enterNewUi = this.state.sendNewNotif
            ? <div>
                <h3> MANUAL ENTRY</h3>

                <SingleDatePicker
                    date={this.state.date} // momentPropTypes.momentObj or null
                    //onDateChange={date => this.setState({ date })} // PropTypes.func.isRequired
                    onDateChange={date => this.dateSelectOnChange(date)} // PropTypes.func.isRequired
                    focused={this.state.focused} // PropTypes.bool
                    onFocusChange={({ focused }) => this.setState({ focused })} // PropTypes.func.isRequired
                    isOutsideRange={() => false}
                />
                <h3>{this.state.dateString}</h3>


                {/* REASON */}
                <label> REASON - {this.state.fromWhereZapier} </label>
                <Select
                    name="form-field-name"
                    value={this.state.fromWhereZapierStockAcc}
                    options={this.state.fromWhereZapierStockAccOptions}
                    onChange={this.handleDropDownChanges}
                    searchable={false}
                    clearable={false}
                />

                {/* PROJECT */}
                <br />
                <label> PROJECT </label>
                <Select
                    name="form-field-name"
                    value={this.state.project}
                    options={this.state.openProjectsDropdownItemList}
                    onChange={this.handleDropDownChanges}
                    searchable={true}
                    clearable={false}
                />


                {/* REQUISITIONS */}
                <ViewRequisitionsDropdown
                    user={this.state.user}
                    unpaid_req={this.state.unpaid_req}
                    handleDropDownChanges={this.handleDropDownChanges}
                    title="Requisiton (Optional)"
                    type="all" />

                <Form size='large' onSubmit={this.manualEnterZapierLog}>
                    <Segment stacked>

                        {/* amount */}
                        <Form.Field>
                            <label>Amount </label>
                            <label>{toCurrency(this.state.amount)}</label>
                            <Form.Input
                                fluid
                                name={'amount'}
                                value={this.state.amount}
                                icon='add user'
                                iconPosition='left'
                                placeholder='amount'
                                // onFocus={props.amp_logFieldClick}
                                onChange={this.handleTextInputChange}
                                type='number' />
                        </Form.Field>

                        {/* depositAmount*/}
                        <Form.Field>
                            <label>Note</label>
                            <Form.Input
                                fluid
                                name={'reason'}
                                value={this.state.reason}
                                icon='add user'
                                iconPosition='left'
                                placeholder='Note'
                                onChange={this.handleTextInputChange}
                                type='text' />
                        </Form.Field>

                        <Button color='blue' fluid size='large'>SEND</Button>
                    </Segment>
                </Form>

            </div>
            : ''

        const imagePreview = this.state.docUrl
            ? <Image src={this.state.docUrl} size='medium' centered bordered shape='rounded' />
            : ''

        const fileUploadUI = <div>
            <h4>DOCLINK: {this.state.docUrl}</h4>
            <FileUploader
                accept="*,"
                name="avatar"
                filename={this.props.fileName}
                //storageRef={firebaseStorage.ref('orderDesigns/')}
                storageRef={firebaseStorage.ref('printbdocs')}
                onUploadStart={this.handleUploadStart}
                onUploadSuccess={this.handleUploadSuccess}
                onProgress={this.handleProgress}
            />
        </div>

        const putBackUi = this.props.match.params.putBack && (this.state.zapierNotif.miscAck == 'no' || !this.state.zapierNotif.miscAck)
            ? <div>
                <Divider horizontal>{this.props.match.params.putBack}</Divider>
                <Form size='large' onSubmit={this.masterAccountTransferApi}>
                    <Segment stacked>
                        <SingleDatePicker
                            date={this.state.date} // momentPropTypes.momentObj or null
                            //onDateChange={date => this.setState({ date })} // PropTypes.func.isRequired
                            onDateChange={date => this.dateSelectOnChange(date)} // PropTypes.func.isRequired
                            focused={this.state.focused} // PropTypes.bool
                            onFocusChange={({ focused }) => this.setState({ focused })} // PropTypes.func.isRequired
                            isOutsideRange={() => false}
                        />
                        <h3>{this.state.dateString}</h3>
                        {fileUploadUI}
                        {imagePreview}
                        <Button color='blue' fluid size='large'>PUT BACK</Button>
                    </Segment>

                </Form>

            </div>
            : ''

        const putBackUiConfirmed = this.props.match.params.putBack
            && this.state.zapierNotif
            && (this.state.zapierNotif.miscAck == 'capital_put_back' || this.state.zapierNotif.miscAck == 'stockPayment' || this.state.zapierNotif.miscAck == 'vat_payment')
            ? <div>
                <Divider horizontal>{this.props.match.params.putBack}</Divider>
                <Image src={this.state.zapierNotif.docLink} size='medium' centered bordered shape='rounded' />

            </div>
            : ''



        const wholeUI = this.state.user && this.state.user.email && this.state.algoliaUser != null && this.state.algoliaUser.perms && this.state.algoliaUser.perms.includes("UpdateSingleZapierNotif")
            ? <div>

                <h2>    <Button color='red' fluid> <Link to={'/dashboard/getZapierNotifs/'} >BACK</Link> </Button>   </h2>
                {not_confirmedHeader}
                {ackedUi}
                <br />
                {headerStuff}
                <br />
                {confirmForm}
                {enterNewUi}
                {putBackUi}
                {putBackUiConfirmed}

            </div>
            : <h2>YOU ARE NOT AN AUTHORIZED</h2>


        return (
            this.state.loading ? <UiConsts.LoadingComponent /> :
                <div>
                    <h1>ENTER ACC DEP / DEDUCTIONS</h1>
                    {wholeUI}
                </div>
        );
    }
}

export default UpdateSingleZapierNotif;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/zapier/UpdateSingleZapierNotif.js